import {GameVariant, Nullable} from "../caos-def";
import {SetVariantFunc} from "../utils.variants";
import React, {SyntheticEvent} from "react";
import {CommandFilters} from "../commands.filters";


interface PageHeaderParams {
    variant: Nullable<GameVariant>;
    setVariant: SetVariantFunc;
    setQuery: (string: Nullable<string>, searchDescriptions?: Nullable<boolean>) => void;
    query: Nullable<string>;
    useSeaMonkeys: boolean;
    getUrl: () => Promise<string>;
    searchDescriptions: boolean;
}

const _selectVariants = ["All", "C1", "C2", "CV", "C3", "DS", "SM"];

export default function PageHeaderElement(
    {
        variant,
        setVariant,
        setQuery,
        useSeaMonkeys,
        query: _query, getUrl,
        searchDescriptions: _searchDescriptions
    }: PageHeaderParams
): React.JSX.Element {

    const variants = useSeaMonkeys ? _selectVariants : _selectVariants.filter(v => v != "SM");

    const options = variants.map(v => {
        return <option key={"variant-select-variant-" + v.toLowerCase()} value={v}>{v}</option>
    })

    function onVariantChange(event: React.ChangeEvent) {
        const select = (event.target as HTMLElement)?.closest("select")
        if (select == null) {
            return;
        }

        let value: Nullable<string> = select.value.toUpperCase();

        if (value === "ALL") {
            value = null;
        }

        if (value === variant) {
            return;
        }

        setVariant(value as Nullable<GameVariant>, false);
        updateSearchFormUrl();
    }


    function getSearchDescriptions(e: SyntheticEvent): boolean {
        const form = (e.target as HTMLElement)
            ?.closest("form");

        if (form == null) {
            console.error("Failed to find form for get search-descriptions");
            return CommandFilters.SEARCH_DESCRIPTIONS_DEFAULT;
        }

        const checkbox = (form
            .querySelector("input[name='search-descriptions']")) as HTMLInputElement;

        if (checkbox == null) {
            console.error("Failed to find search-descriptions checkbox in form");
            return CommandFilters.SEARCH_DESCRIPTIONS_DEFAULT;
        }
        return checkbox.checked;
    }

    function onSearchDescriptionsChange(e: React.SyntheticEvent){
        const searchDescriptions = getSearchDescriptions(e);
        if (searchDescriptions === _searchDescriptions) {
            return;
        }
        setQuery(_query, searchDescriptions);
    }


    function onSearch(event: React.FormEvent) {

        const field = (event.target as HTMLElement)?.closest("input[type='search']") as HTMLInputElement;

        if (field == null) {
            return;
        }
        const query = field.value.trimStart();

        if (query === _query) {
            return;
        }

        setQuery(query ? query : null, _searchDescriptions);
        updateSearchFormUrl();
    }

    function updateSearchFormUrl() {
        const searchForm = document.getElementById("search-form");
        if (searchForm == null) {
            console.error("Failed to find search form with id `search-form`")
            return;
        }
        getUrl()
            .then((searchUrl: string) => {
                if (searchUrl == null || searchUrl.trim().length === 0) {
                    window.location.href;
                }
                searchForm.setAttribute("action", searchUrl);
            })
            .catch(() => {
                const searchUrl = window.location.href;
                searchForm.setAttribute("action", searchUrl);
            });
    }

    function clearSearch(e: React.MouseEvent) {
        e.preventDefault();
        setQuery(null);
        return false;
    }

    return <header>
        <h1>CAOS Guide</h1>
        <label id="variant-select-container">
            <span>Game: </span>
            <select key="variant-select" onChange={onVariantChange} value={variant ?? "All"}>
                {options}
            </select>
        </label>
        <span className="fill"></span>
        <form method="GET" action="./" id="search-form">
            <label className="search-container">
                <span>Search:</span>
                <input autoCapitalize="off"
                       autoComplete="off"
                       autoFocus={true}
                       type="search"
                       placeholder="Enter caos command..."
                       id="search"
                       name="query"
                       onInput={onSearch}
                       onKeyUp={onSearch}
                       onChange={onSearch}
                       value={_query ?? ""}
                />
                <button className="clear-search" onClick={clearSearch} aria-label="clear" type="reset">x</button>
                <button type="submit" className="search-button" id="search-button" aria-label="search"><img src="./icons/search.png" alt="search" /></button>
            </label>
            <div id="search-drop-down">
                <div className="input-field">
                <label className="search-descriptions-container" htmlFor="search-descriptions">
                    <input type="checkbox"
                           checked={_searchDescriptions}
                           onChange={onSearchDescriptionsChange}
                           onInput={onSearchDescriptionsChange}
                           name="search-descriptions"
                           id="search-descriptions"
                    />
                    <span>Search Descriptions</span>
                </label>
                </div>
            </div>
        </form>
    </header>
}